import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useEffect } from "react";
import {
  $getSelection,
  $isRangeSelection,
  createCommand,
  LexicalCommand,
} from "lexical";
import { $createMergeFieldNode } from "../merge-field-node";

export const INSERT_MERGE_FIELD_COMMAND: LexicalCommand<string> =
  createCommand();

export function MergeFieldPlugin() {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand(
      INSERT_MERGE_FIELD_COMMAND,
      (name: string) => {
        editor.update(() => {
          const selection = $getSelection();
          if ($isRangeSelection(selection)) {
            const node = $createMergeFieldNode(name);
            selection.insertNodes([node]);
          }
        });
        return true;
      },
      0
    );
  }, [editor]);

  return null;
}
